import retrieveUserToken from '../utils/user-token';
import backendFactories from './backends';
export default (props, updateContext, getContext) => {
  var backends = backendFactories(props);
  var _props$shared = props.shared,
    shared = _props$shared === void 0 ? {} : _props$shared;
  var toggledFeatures = shared.toggledFeatures,
    isEuUser = shared.isEuUser,
    addListener = shared.addListener;
  var ANALYTICS_DEBUG = toggledFeatures.ANALYTICS_DEBUG;
  var sendAnalytics = event => {
    if (isEuUser) {
      if (ANALYTICS_DEBUG) {
        console.info('fe-co-allhomes-api: dropping event for EU User', event); // eslint-disable-line no-console
      }
      return;
    }
    var _ref = getContext() || {},
      user = _ref.user;
    var dateCreated = new Date();
    var globalData = {
      dateCreated,
      user
    };
    Object.keys(event).filter(key => backends[key]).map(key => new Promise(resolve => {
      if (ANALYTICS_DEBUG) {
        // eslint-disable-next-line no-console
        console.info("fe-co-allhomes-api: sending ".concat(key, " event"), event[key]);
      }
      resolve(backends[key](event[key], globalData));
    }));
  };
  addListener(() => {
    var _ref2 = getContext() || {},
      analyticsToken = _ref2.analyticsToken;
    if (!analyticsToken) {
      updateContext({
        analyticsToken: retrieveUserToken()
      });
    }
  });
  return {
    sendAnalytics,
    analyticsToken: null
  };
};